import React from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../components/Logo';
import './Contact.css';

const Contact: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="contact-page">
      <header className="contact-header">
        <div className="header-content">
          <button onClick={() => navigate(-1)} className="back-button">
            ← Back
          </button>
          <div className="brand-logo" onClick={() => navigate('/')}>
            <Logo height={34} />
          </div>
        </div>
      </header>

      <main className="contact-main">
        <div className="contact-content">
          <div className="contact-hero">
            <span className="hero-icon">💬</span>
            <h1>Contact Us</h1>
            <p>We'd love to hear from you</p>
          </div>

          <div className="contact-grid">
            {/* General Inquiries */}
            <div className="contact-card">
              <div className="card-icon">📧</div>
              <h3>Email Us</h3>
              <p>Questions, support, or partnerships</p>
              <a href="mailto:info@lomistudy.com" className="contact-link">
                info@lomistudy.com
              </a>
            </div>

            {/* Telegram channel (one-way feed) */}
            <div className="contact-card">
              <div className="card-icon">📢</div>
              <h3>Channel</h3>
              <p>Daily questions & leaderboard</p>
              <a href="https://t.me/lomistudy" target="_blank" rel="noopener noreferrer" className="contact-link">
                t.me/lomistudy
              </a>
            </div>

            {/* Community group (the conversation) */}
            <div className="contact-card">
              <div className="card-icon">💬</div>
              <h3>Community</h3>
              <p>Ask, share & help shape Lomi</p>
              <a href="https://t.me/lomicommunity" target="_blank" rel="noopener noreferrer" className="contact-link">
                t.me/lomicommunity
              </a>
            </div>

            {/* TikTok */}
            <div className="contact-card">
              <div className="card-icon">🎵</div>
              <h3>TikTok</h3>
              <p>Study tips and updates</p>
              <a href="https://tiktok.com/@lomistudy" target="_blank" rel="noopener noreferrer" className="contact-link">
                @lomistudy
              </a>
            </div>

            {/* Location */}
            <div className="contact-card">
              <div className="card-icon">📍</div>
              <h3>Location</h3>
              <p>Based in Ethiopia</p>
              <span className="contact-link">Addis Ababa</span>
            </div>
          </div>

          {/* Social Media */}
          <section className="social-section">
            <h2>Follow Us</h2>
            <p>Stay updated on Lomi news and study tips</p>
            <div className="social-links">
              <a href="https://t.me/lomistudy" target="_blank" rel="noopener noreferrer" className="social-link telegram">
                <svg viewBox="0 0 24 24" width="24" height="24">
                  <path fill="currentColor" d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                </svg>
                <span>t.me/lomistudy</span>
              </a>
              <a href="https://tiktok.com/@lomistudy" target="_blank" rel="noopener noreferrer" className="social-link tiktok">
                <svg viewBox="0 0 24 24" width="24" height="24">
                  <path fill="currentColor" d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
                </svg>
                <span>@lomistudy</span>
              </a>
            </div>
          </section>
        </div>
      </main>

      <footer className="contact-footer">
        <div className="footer-brand">
          <Logo height={28} />
        </div>
        <p>Fresh learning for every Ethiopian student</p>
      </footer>
    </div>
  );
};

export default Contact;
